// extracted by mini-css-extract-plugin
module.exports = {"spinner":"SimpleLoader_spinner__uXULO","pending-spinner":"SimpleLoader_pending-spinner__GSDeD"};